/* ==============================================
   IKM CART DRAWER – Interactions
   Open / close, quantity updates, remove,
   section rendering, product recommendations
   ============================================== */

(function () {
  'use strict';

  /* ── DOM refs ── */
  var drawer    = document.querySelector('[data-ikm-cart-drawer]');
  var closeBtns = document.querySelectorAll('[data-ikm-cart-drawer-close]');
  var openBtns  = document.querySelectorAll('[data-ikm-cart-drawer-open]');

  if (!drawer) return;

  /* Move drawer to body root so it escapes any parent stacking context */
  document.body.appendChild(drawer);

  /* ── State ── */
  var isOpen            = false;
  var isUpdating        = false;
  var cachedRecoHtml    = '';
  var lastRecoProductId = null;

  /* ===========================
     OPEN / CLOSE
     =========================== */
  function openCartDrawer(e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    if (isOpen) return;
    isOpen = true;
    drawer.classList.add('ikm-cart-drawer--open');
    document.body.classList.add('ikm-cart-drawer-body--open');
    document.body.style.overflow = 'hidden';

    /* Fetch recommendations on open */
    var productId = window.IKM_CART_FIRST_PRODUCT_ID;
    if (productId && productId !== lastRecoProductId) {
      fetchRecommendations(productId);
    }
  }

  function closeCartDrawer() {
    if (!isOpen) return;
    isOpen = false;
    drawer.classList.remove('ikm-cart-drawer--open');
    document.body.classList.remove('ikm-cart-drawer-body--open');
    document.body.style.overflow = '';
  }

  /* Bind open buttons (from header) */
  openBtns.forEach(function (btn) {
    btn.addEventListener('click', openCartDrawer);
  });

  /* Bind close button */
  closeBtns.forEach(function (btn) {
    btn.addEventListener('click', closeCartDrawer);
  });

  /* Close on overlay (body::after) click */
  document.addEventListener('click', function (e) {
    if (!isOpen) return;
    /* If click is outside the drawer, close it */
    if (!drawer.contains(e.target) && !e.target.closest('[data-ikm-cart-drawer-open]')) {
      closeCartDrawer();
    }
  });

  /* Close on Escape */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen) closeCartDrawer();
  });

  /* ===========================
     CART ITEM EVENTS (delegation)
     =========================== */
  drawer.addEventListener('click', function (e) {
    if (isUpdating) return;

    var target = e.target;

    /* ── Quantity minus ── */
    if (target.closest('[data-ikm-cart-qty-minus]')) {
      var lineItem = target.closest('[data-ikm-cart-line-item]');
      if (!lineItem) return;
      var key = lineItem.getAttribute('data-line-key');
      var qtyEl = lineItem.querySelector('.ikm-cart-drawer__qty-value');
      var currentQty = parseInt(qtyEl.textContent, 10);
      if (currentQty > 1) {
        updateCartItem(key, currentQty - 1, lineItem);
      }
      return;
    }

    /* ── Quantity plus ── */
    if (target.closest('[data-ikm-cart-qty-plus]')) {
      var lineItem2 = target.closest('[data-ikm-cart-line-item]');
      if (!lineItem2) return;
      var key2 = lineItem2.getAttribute('data-line-key');
      var qtyEl2 = lineItem2.querySelector('.ikm-cart-drawer__qty-value');
      var currentQty2 = parseInt(qtyEl2.textContent, 10);
      updateCartItem(key2, currentQty2 + 1, lineItem2);
      return;
    }

    /* ── Remove ── */
    if (target.closest('[data-ikm-cart-remove]')) {
      var lineItem3 = target.closest('[data-ikm-cart-line-item]');
      if (!lineItem3) return;
      var key3 = lineItem3.getAttribute('data-line-key');
      updateCartItem(key3, 0, lineItem3);
      return;
    }
  });

  /* ===========================
     CART UPDATE (change.js + section rendering)
     =========================== */
  function updateCartItem(key, quantity, lineItemEl) {
    if (isUpdating) return;
    isUpdating = true;

    /* Visual feedback */
    if (lineItemEl) lineItemEl.classList.add('ikm-cart-drawer__line-item--updating');

    fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        /* Update header cart count badge */
        updateHeaderCount(cart.item_count);

        /* Store new first product id */
        if (cart.items && cart.items.length > 0) {
          window.IKM_CART_FIRST_PRODUCT_ID = cart.items[0].product_id;
        } else {
          window.IKM_CART_FIRST_PRODUCT_ID = null;
        }

        /* Re-render drawer via Section Rendering API */
        return refreshDrawerSection();
      })
      .then(function () {
        isUpdating = false;

        /* Refresh recommendations if product changed */
        var newProdId = window.IKM_CART_FIRST_PRODUCT_ID;
        if (newProdId && newProdId !== lastRecoProductId) {
          fetchRecommendations(newProdId);
        } else if (!newProdId) {
          clearRecommendations();
        } else {
          restoreRecommendations();
        }
      })
      .catch(function (err) {
        console.error('[IKM Cart Drawer] Update error:', err);
        isUpdating = false;
        if (lineItemEl) lineItemEl.classList.remove('ikm-cart-drawer__line-item--updating');
      });
  }

  /* ===========================
     SECTION RENDERING
     =========================== */
  function refreshDrawerSection() {
    var url = window.location.pathname + '?sections=ikm-cart-drawer';

    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var sectionHtml = data['ikm-cart-drawer'];
        if (!sectionHtml) return;

        /* Parse the returned section HTML */
        var tempDiv = document.createElement('div');
        tempDiv.innerHTML = sectionHtml;

        var newContent = tempDiv.querySelector('[data-ikm-cart-drawer-content]');
        var existingContent = drawer.querySelector('[data-ikm-cart-drawer-content]');

        if (newContent && existingContent) {
          existingContent.innerHTML = newContent.innerHTML;
        }

        /* Update the reco column visibility */
        var recoCol = drawer.querySelector('[data-ikm-cart-reco-col]');
        var newRecoCol = tempDiv.querySelector('[data-ikm-cart-reco-col]');
        if (recoCol && newRecoCol) {
          recoCol.style.display = newRecoCol.style.display;
        }

        /* Re-bind close button inside new content */
        var newCloseBtn = drawer.querySelector('[data-ikm-cart-drawer-close]');
        if (newCloseBtn) {
          newCloseBtn.addEventListener('click', closeCartDrawer);
        }
      });
  }

  /* ===========================
     HEADER CART COUNT
     =========================== */
  function updateHeaderCount(count) {
    /* Update the header badge */
    var badge = document.querySelector('.ikm-header__cart-count');
    if (badge) {
      badge.textContent = count;
      badge.style.display = count > 0 ? '' : 'none';
    } else if (count > 0) {
      /* Create badge if it doesn't exist */
      var cartLink = document.querySelector('.ikm-header__cart-link');
      if (cartLink) {
        var span = document.createElement('span');
        span.className = 'ikm-header__cart-count';
        span.textContent = count;
        cartLink.appendChild(span);
      }
    }

    /* Update aria-label on cart icon */
    var cartLink2 = document.querySelector('.ikm-header__cart-link');
    if (cartLink2) {
      cartLink2.setAttribute('aria-label', 'Cart (' + count + ' items)');
    }
  }

  /* ===========================
     PRODUCT RECOMMENDATIONS
     Uses Section Rendering API with card-product.liquid snippet
     =========================== */
  function fetchRecommendations(productId) {
    if (!productId) return;

    var url = '/recommendations/products?product_id=' + productId
            + '&limit=6&section_id=ikm-cart-drawer-reco';

    fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        /* Parse the returned section HTML */
        var tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;

        var resultsEl = tempDiv.querySelector('[data-ikm-cart-reco-results]');
        if (resultsEl && resultsEl.children.length > 0) {
          lastRecoProductId = productId;
          cachedRecoHtml = resultsEl.innerHTML;
          injectRecommendations();
        }
      })
      .catch(function (err) {
        console.error('[IKM Cart Drawer] Recommendations error:', err);
      });
  }

  function injectRecommendations() {
    if (!cachedRecoHtml) return;

    /* Desktop column */
    var desktopContainer = drawer.querySelector('[data-ikm-cart-reco-desktop]');
    if (desktopContainer) {
      desktopContainer.innerHTML = cachedRecoHtml;
    }

    /* Mobile horizontal scroll */
    var mobileContainer = drawer.querySelector('[data-ikm-cart-reco-mobile]');
    if (mobileContainer) {
      mobileContainer.innerHTML = cachedRecoHtml;
    }

    /* Show mobile section */
    var mobileSection = drawer.querySelector('[data-ikm-cart-reco-section]');
    if (mobileSection) {
      mobileSection.style.display = '';
    }

    /* Show desktop column */
    var recoCol = drawer.querySelector('[data-ikm-cart-reco-col]');
    if (recoCol) {
      recoCol.style.display = '';
    }
  }

  function restoreRecommendations() {
    /* Called after section re-render to put cached reco HTML back */
    if (cachedRecoHtml) {
      injectRecommendations();
    }
  }

  function clearRecommendations() {
    cachedRecoHtml = '';
    lastRecoProductId = null;

    var desktopContainer = drawer.querySelector('[data-ikm-cart-reco-desktop]');
    if (desktopContainer) desktopContainer.innerHTML = '';

    var mobileContainer = drawer.querySelector('[data-ikm-cart-reco-mobile]');
    if (mobileContainer) mobileContainer.innerHTML = '';

    var recoCol = drawer.querySelector('[data-ikm-cart-reco-col]');
    if (recoCol) recoCol.style.display = 'none';
  }

  /* ===========================
     LISTEN FOR CUSTOM ADD-TO-CART EVENTS
     (so the drawer can open automatically after adding)
     =========================== */
  document.addEventListener('ikm:cart:updated', function () {
    if (isOpen) {
      refreshDrawerSection().then(function () {
        var newProdId = window.IKM_CART_FIRST_PRODUCT_ID;
        if (newProdId) fetchRecommendations(newProdId);
      });
    }
  });

  /* Optional: auto-open after add-to-cart */
  document.addEventListener('ikm:cart:added', function () {
    /* Refresh first, then open */
    refreshDrawerSection().then(function () {
      openCartDrawer();
      var newProdId = window.IKM_CART_FIRST_PRODUCT_ID;
      if (newProdId) fetchRecommendations(newProdId);
    });
  });

})();
